export default {
    url: '/detail/:id',
    template: '<courses-rooms-detail room="vm.room"/>',
    resolve: {
        room (RoomResource, $stateParams) {
            return RoomResource.get({ id: $stateParams.id }).$promise;
        }
    },
    controller (room) {
        this.room = room;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/rooms/detail/index.js